import { Attachment } from './attachments.model';
import { FlowchartElementType } from './FlowchartElementType';
import { FlowchartNodeDto } from './FlowchartNodeDto';

export class FlowchartTextBlockDto extends FlowchartNodeDto {
  content?: string;
  attachments?: Attachment[];
  elementType?: FlowchartElementType;
}
